import * as storage from '@src/common/storage';

export const planneWidgetBuyerKey = 'planneWidgetUser';

// The cookie outlives the store, and setupAuth only writes the token into state after an awaited
// getOwnBuyer — so during boot the cookie is the only place the token is.
export const readBuyerToken = (publicApiKey: string | undefined, stateToken: string | undefined) =>
  publicApiKey == null ? undefined : storage.getValue(publicApiKey, planneWidgetBuyerKey) ?? stateToken;
